function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea5dc"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea5dc"] = parcelRequire;
}
parcelRequire.register("kPjk6", function(module, exports) {

$parcel$export(module.exports, "register", () => $f2978f409edd0d96$export$6503ec6e8aabbaf, (v) => $f2978f409edd0d96$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f2978f409edd0d96$export$f7ad0328861e2f03, (v) => $f2978f409edd0d96$export$f7ad0328861e2f03 = v);
var $f2978f409edd0d96$export$6503ec6e8aabbaf;
var $f2978f409edd0d96$export$f7ad0328861e2f03;
"use strict";
var $f2978f409edd0d96$var$mapping = {};
function $f2978f409edd0d96$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$f2978f409edd0d96$var$mapping[keys[i]] = pairs[keys[i]];
}
function $f2978f409edd0d96$var$resolve(id) {
    var resolved = $f2978f409edd0d96$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$f2978f409edd0d96$export$6503ec6e8aabbaf = $f2978f409edd0d96$var$register;
$f2978f409edd0d96$export$f7ad0328861e2f03 = $f2978f409edd0d96$var$resolve;

});

var $ab1ddb5dc46eba97$exports = {};

(parcelRequire("kPjk6")).register(JSON.parse('{"jRPZQ":"index.04b50fbb.js","5KTmA":"wyvern-blue.d40454e2.png","eY5ds":"index.0f68c131.css"}'));


//# sourceMappingURL=index.2748b415.js.map
